import { type TableColumnsType } from 'antd';
import type { BillingReportTableRow } from '@app/services/billingReports.types';

export const BASE_COLUMNS: TableColumnsType<BillingReportTableRow> = [
    {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: (value, row) => {
            return (
                <div className={`category ${row?.key?.split('-')[1] === 'header' ? 'header' : ''}`}>
                    {value}
                </div>
            );
        },
    },
    { title: 'Channel Partner', dataIndex: 'channel_partner', key: 'channel_partner' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount' },
    {
        title: 'Unit',
        dataIndex: 'unit',
        key: 'unit',
        render: (value, row) => {
            const keyArr = row?.key?.split('-');
            if (keyArr.length === 2 && keyArr[1].includes('total')) {
                return <div className={keyArr[1]}>{value}</div>;
            } else {
                return value;
            }
        },
    },
];
